export const DEFAULT_CIAN_DOMAIN = 'cian.ru';
